// components/ErrorBoundary.js
import React from 'react'
import analyticsService from '../services/analyticsService'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      errorCount: 0
    }
  }

  static getDerivedStateFromError (error) {
    return { hasError: true }
  }

  componentDidCatch (error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo)

    // Analytics tracken
    analyticsService.trackError('react_error_boundary', {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      severity: 'critical'
    })

    this.setState(prevState => ({
      error,
      errorInfo,
      errorCount: prevState.errorCount + 1
    }))

    // Nach 3 Errors auto-reload (Infinite Loop Prevention)
    if (this.state.errorCount >= 2) {
      setTimeout(() => {
        window.location.reload()
      }, 2000)
    }
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    })

    analyticsService.trackUserAction('error_boundary_reset')
  }

  render () {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '2rem',
            backgroundColor: '#f5f5f5',
            textAlign: 'center'
          }}
        >
          <div
            style={{
              background: 'white',
              padding: '3rem',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              maxWidth: '600px'
            }}
          >
            <h1 style={{ color: '#f44336', marginBottom: '1rem' }}>
              🚨 Etwas ist schiefgelaufen
            </h1>

            <p
              style={{
                color: '#666',
                fontSize: '1.1rem',
                marginBottom: '2rem'
              }}
            >
              Die Anwendung ist auf einen Fehler gestoßen. Wir wurden
              automatisch benachrichtigt.
            </p>

            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details
                style={{
                  textAlign: 'left',
                  marginBottom: '2rem',
                  background: '#f5f5f5',
                  padding: '1rem',
                  borderRadius: '6px',
                  fontSize: '0.85rem'
                }}
              >
                <summary
                  style={{
                    cursor: 'pointer',
                    fontWeight: 600,
                    marginBottom: '0.5rem'
                  }}
                >
                  Fehlerdetails (Entwicklermodus)
                </summary>
                <pre style={{ overflow: 'auto', fontSize: '0.75rem' }}>
                  {this.state.error.toString()}
                  {'\n\n'}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}

            <div
              style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}
            >
              <button
                onClick={this.handleReset}
                style={{
                  background: '#1976d2',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 2rem',
                  borderRadius: '6px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}
              >
                Erneut versuchen
              </button>

              <button
                onClick={() => (window.location.href = '/')}
                style={{
                  background: '#757575',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 2rem',
                  borderRadius: '6px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}
              >
                Zur Startseite
              </button>
            </div>

            {this.state.errorCount >= 2 && (
              <p
                style={{
                  marginTop: '1.5rem',
                  color: '#ff9800',
                  fontSize: '0.9rem'
                }}
              >
                ⚠️ Die Seite wird in wenigen Sekunden neu geladen...
              </p>
            )}
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
